import type { ReactNode } from 'react'

/**
 * `.banner.ok|.warn|.sending[.prominent]`, role=status. A prominent banner takes a headline and a
 * line of text. `sending` is the neutral wait while a just-submitted order's email goes out.
 */
export function Banner({
  kind,
  headline,
  children,
}: {
  kind: 'ok' | 'warn' | 'sending'
  headline?: string
  children: ReactNode
}) {
  if (headline === undefined)
    return (
      <div className={`banner ${kind}`} role="status">
        {children}
      </div>
    )
  return (
    <div className={`banner ${kind} prominent`} role="status">
      <div>
        <strong>{headline}</strong>
        <span>{children}</span>
      </div>
    </div>
  )
}

/** A load failure: `.banner.warn` with a retry button (role=alert, so it is announced). */
export function LoadFailed({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="banner warn load-failed" role="alert">
      <span>{message}</span>
      <button type="button" className="btn text" data-icon="refresh" onClick={onRetry}>
        Retry
      </button>
    </div>
  )
}
